export default {
  title: '{type} importieren',
};
